import { contextFactory } from '@frontend/design-system';
import { KioskTypes } from '../../../../types';

export interface KioskFormsContextProps {
  locationId: string;
  patronType: KioskTypes.Patron;
}

export const [KioskFormsContext, useKioskFormsContext] = contextFactory<KioskFormsContextProps>();
